<template>
  <el-dialog
    title="Selecionar Pasta"
    :visible.sync="visibility"
    :before-close="fechar"
    :modal-append-to-body="false"
    @open="recuperarDiretorios"
    width="35%"
  >
    <el-form size="small" label-position="top">
      <el-form-item label="Formulário">
        <el-input v-model="formulario.nome" readonly/>
      </el-form-item>

      <el-form-item label="Diretórios">
        <el-select v-model="diretorio.id"
          placeholder="Diretórios"
          filterable
          loading-text="Carregando...">
          <el-option
            v-for="item in diretorios"
            :key="item.id"
            :label="item.nome"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="selecionarDiretorio()" type="primary">Selecionar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
import URLS from '../../util/urls.js';
import axios from 'axios';

export default {
  props: {
    visibility: Boolean,
    venda: Object,
    formulario: Object
  },
  data() {
    return {
      diretorio: {
        id: undefined,
        tipoFormularios: 'VENDA'
      },
      diretorios: []
    };
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("vendasStore", ["selecionarDiretorioVenda"]),

    selecionarDiretorio() {
      this.showLoading();
      
      this.formulario["diretorio"] = this.diretorio;

      if (this.venda !== undefined && this.venda.id != 0) {
        this.formulario["idObjeto"] = this.venda.id;
        this.formulario["tipo"] = "VENDA";

        this.selecionarDiretorioVenda(this.formulario).then(resultado => {
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
          }

          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
        
      }
    },
    recuperarDiretorios() {
      let payload = {
        tipoFormularios: 'VENDA',
      };
      axios.post(URLS.FORMULARIOS_LISTAR_DIRETORIOS, payload)
        .then(resultado => {
          switch (resultado.data.status) {
              case "SUCESSO":
                this.diretorios = resultado.data.lista;
                break;
              case "FALHA":
              case "ERRO":
                this.$message.error(resultado.mensagem);
            }
        }).catch(() => {
          this.$message.error("Ocorreu um erro.");
        });
    },
    fechar() {
      this.$emit("close");
    }
  }
};
</script>

